// extracted by mini-css-extract-plugin
export default {"wrapper_input":"styles_wrapper_input__PS9sn","input":"styles_input__VTh+h","buttonDeleteSearch":"styles_buttonDeleteSearch__w8O+1"};